export const MODAL_TYPE_MOVE_CATEGORY_CONFIRMATION = 'move-category-confirmation';
